angular.module('SpidApp')

.constant('STOCKFLOW_CONFIG', {
	type: {
		  input  	: 'IN'
		, output	: 'OUT'
		, reconcil	: 'REC'
	}
})

.factory('StockFlow', ['STOCKFLOW_CONFIG', function (STOCKFLOW_CONFIG) {
	var StockFlow = function (params) {
		params = params || {}
		this.orderable_id	= params.orderable_id
		this.agency_id  	= params.agency_id
		this.diff 			= params.diff
		this.current		= params.current
		this.type			= params.type
		this.updated_at		= params.updated_at
	}
	
	StockFlow.prototype.initFromStockProduct = function (stockProduct, agencyId) {
		this.orderable_id 	= stockProduct.product.id;
		this.agency_id 		= agencyId;
		this.diff 			= stockProduct.quantity - stockProduct.qtyOrigine;
		this.current		= stockProduct.quantity || 0;
	}
	
	StockFlow.prototype.setTypeInput = function () {
		this.type = STOCKFLOW_CONFIG.type.input;
	}
	
	StockFlow.prototype.setTypeOutput = function () {
		this.type = STOCKFLOW_CONFIG.type.output;
	}
	
	StockFlow.prototype.setTypeRec = function () {
		this.type = STOCKFLOW_CONFIG.type.reconcil;
	}
	
	return StockFlow
}])